<template>
  <div class="filter-list-el">
    <div class="row justify-left full-width q-py-none no-wrap">
      <q-btn
        v-if="theModel.Descriptor !== 5 && theModel.Descriptor !== 7 && theModel.Descriptor !== 11"
        ref="triggerBtn"
        class="q-my-none unset-items-center"
        flat
        dense
        round
        icon="add"
        size="sm"
        color="grey-8"
        @click="addNewFilter"
        @mousedown.stop.prevent
        @mouseup.stop.prevent
        :aria-label="$t('add_filter')"
      />
      <selector-popup
        v-if="
          isAccessFilter ||
          (theModel.Descriptor === 1 && theModel.Category !== 6) ||
          [3, 4, 9, 10].includes(theModel.Descriptor)
        "
        v-model:visible="isShowingMenu"
        :trigger-el="$refs.triggerBtn"
        :default-width="isAccessFilter ? accessFilterDropdownWidth : 300"
        :max-height="isAccessFilter ? accessFilterDropdownHeight : 500"
        :wide-layout="filterListSelectorWideLayout"
      >
        <AccessFilterDropdownContent
          v-if="isAccessFilter"
          v-model="(theModel as any).Filters"
          @close="isShowingMenu = false"
        />
        <aux-selector
          v-else-if="theModel.Descriptor === 4"
          ref="aux_selector"
          v-model="(theModel as SelectionParametersFilterGroupSend).Parameters"
          :input-index="inputIndex"
          :model-type="theModel.Category === 12 ? 3 : theModel.Category"
          :use-refactored-recursive="true"
          :limit-height-to-container="true"
          :open-on-start="true"
          :allow-multiple="true"
          @selectorClosed="onPanelClosed"
        />
        <aux-selector
          v-else
          ref="aux-selector"
          v-model="(theModel as filterTypes).Filters"
          :input-index="inputIndex"
          :exclude-id="genstore?.selectedItem?.Id"
          :use-refactored-recursive="true"
          :model-type="
            theModel.Descriptor === 9 ? 22 : 
            (theModel.Category === 12 ? 3 : 
              (theModel.Descriptor === 10 ? 23 : theModel.Category))
          "
          :limit-height-to-container="true"
          :allow-multiple="true"
          @selectorClosed="onPanelClosed"
        />
      </selector-popup>
      <!-- col  -->
      <div class="q-py-none">
        <div class="q-mt-xs q-px-xs">
          <!-- col  -->
          <q-item-section class="q-my-xs">
            <div
              :class="[
                'row justify-left full-width q-py-0',
                { 'no-wrap': ![1, 3, 9, 10].includes(theModel.Descriptor) },
              ]"
            >
              <q-item-label
                :class="[{ 'text-red cursor-pointer': isIncorrect }, 'q-mr-xs']"
                >{{ getElementName }}
                <q-tooltip :delay="1000" v-if="isIncorrect">
                  {{ isIncorrect }}
                </q-tooltip>
              </q-item-label>
              <q-btn-toggle
                v-model="theModel.FilterConnector"
                v-if="
                  !isOwnerFilter &&
                  theModel.FilterConnector &&
                  (theModel as filterTypes).Filters?.length > 1
                "
                :class="[
                  'filter-andor-toggle q-pa-none q-my-none',
                  { 'q-mr-none': theModel.Descriptor === 3 },
                ]"
                style="margin-top: -3px"
                no-caps
                unelevated
                dense
                toggle-color="primary"
                color="white"
                text-color="primary"
                :options="[
                  { label: $t('or_label'), value: 1 },
                  { label: $t('and_label'), value: 2 },
                ]"
              />
              <!-- DateStamps -->
              <q-checkbox
                v-model="useInnerModel"
                v-if="theModel.Descriptor === 3"
                :toggle-indeterminate="false"
                :keep-color="false"
                checked-icon="event"
                unchecked-icon="event"
                size="sm"
                color="primary"
                style="margin-top: -10px"
                class="q-mx-none q-px-none cursor-pointer"
              />

              <mosta-checkbox
                v-model="theModel.CalculateFiguresOnlySelectedStorages"
                v-if="theModel.Descriptor === 9 && theModel.Filters?.length"
                :toggle-indeterminate="false"
                style="margin-top: -1px; margin-left: 3px;"
                :label="$t('calc_by_selected')"
                class="q-mx-none q-px-none cursor-pointer"
              />

              <!-- movement storage options -->
              <q-option-group
                v-if="theModel.Descriptor === 10 && theModel.Filters?.length"
                class="q-ml-xs"
                dense
                inline
                multiple
                :model-value="moveFlagSetConditions.map((el) => el.value)"
                @update:model-value="(val) => { changeMoveFlagModel(val)}"
                :options="movementFlagOptions"
                size="xs"
                color="primary"
                type="checkbox"
              />

              <!-- movement type -->
              <q-select
                v-else-if="theModel.Descriptor === 14"
                flat
                v-model="moveTypeModel"
                hide-bottom-space
                multiple
                :label-slot="false"
                :bottom-slots="false"
                dense
                outlined
                class="thin-input no-padding-inside q-ml-xs"
                style="min-width: 100px; margin-top: -5px;"
                input-debounce="500"
                :label="
                !moveTypeModel || !moveTypeModel.length
                  ? $t('filter_empty')
                  : ''
                "
                ref="move_type_select"
                :hide-dropdown-icon="false"
                options-html
                :options="moveTypeOptions"
              >
              </q-select>

              <date-range-display-item
                v-if="theModel.Descriptor === 3 && useInnerModel"
                v-model="innerRange"
                :modelType="theModel.Descriptor"
                :shift-top="true"
              />

              <div
                v-if="
                  theModel.Descriptor === 1 &&
                  commonRoleOptions &&
                  commonRoleOptions.length
                "
                @click="($refs.roles_select as any).showPopup()"
                class="cursor-pointer q-mx-sm text-bold text-grey-8"
                style="margin-top: -2px"
              >
                #
              </div>

              <!-- common role -->
              <div
                class="row no-wrap"
                v-for="(role, ri) in theModel.Descriptor === 1
                  ? commonRolesModel
                  : []"
                :key="ri"
                style="float: left; margin-right: 5px; margin-top: -2px"
              >
                <div>{{ role.label }}</div>
                <q-btn
                  class="q-pa-none q-ma-none"
                  flat
                  dense
                  :aria-label="$t('remove')"
                  icon="close"
                  size="xs"
                  @click="
                    () => {
                      commonRolesModel = commonRolesModel.filter(
                        (el, index) => index != ri
                      );
                    }
                  "
                />
              </div>

              <q-select
                flat
                v-if="
                  theModel.Descriptor === 1 &&
                  commonRoleOptions &&
                  commonRoleOptions.length
                "
                v-model="commonRolesModel"
                class="no-select-border q-mb-xs"
                hide-bottom-space
                fill-input
                multiple
                :label-slot="false"
                :bottom-slots="false"
                dense
                outlined
                :style="'max-width: 40vw; max-height: 0; overflow: hidden;'"
                input-debounce="500"
                label=""
                ref="roles_select"
                :hide-dropdown-icon="true"
                :options="commonRoleOptions"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      {{ $t("no_data_found") }}
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
              <!-- </div> -->
            </div>
          </q-item-section>
        </div>
      </div>
    </div>
    <!-- col  -->
    <div class="q-py-none">
      <div class="q-mt-xs q-px-xs">
        <!-- col  -->
        <q-item-section class="q-my-xs" style="flex-wrap: nowrap">
          <!-- list filters: -->
          <div v-if="[0, 1, 2, 3, 8, 9, 10, 12, 14, 15].includes(theModel.Descriptor)">
            <variable-display-list
              v-model="(theModel as filterTypes).Filters"
              @itemDeleted="deleteItem"
              :modelType="displayFilterDescriptor"
              :modelCategory="theModel.Category === 12 ? 3 : theModel.Category"
              :role-options="(theModel as SelectionEntityWithRolesFilterGroupSend).Roles?.map((el: any) => {
              return {
                label: el.Name,
                value: el
              }
            })"
            />
          </div>
          <!-- root parameters -->
          <div v-else-if="theModel.Descriptor === 4">
            <variable-display-list
              v-model="(modelValue as SelectionParametersFilterGroupSend).Parameters"
              @itemDeleted="deleteItem"
              :modelType="theModel.Descriptor"
              :modelCategory="theModel.Category === 12 ? 3 : theModel.Category"
              :display-selected="true"
            />
          </div>
          <!-- single filters: -->
          <!-- job status -->
          <div v-else-if="theModel.Descriptor === 5">
            <q-select
              flat
              v-model="jobStatusModel"
              class="no-select-border q-mb-xs"
              hide-bottom-space
              multiple
              :label-slot="false"
              :bottom-slots="false"
              dense
              outlined
              clearable
              input-debounce="500"
              :label="
                !jobStatusModel || !jobStatusModel.length
                  ? $t('filter_empty')
                  : ''
              "
              ref="job_status_select"
              :hide-dropdown-icon="false"
              :options="jobStatusOptions"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("no_data_found") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <!-- tag status -->
          <div v-else-if="theModel.Descriptor === 7">
            <q-select
              flat
              v-model="tagStatusModel"
              class="no-select-border q-mb-xs"
              hide-bottom-space
              multiple
              :label-slot="false"
              :bottom-slots="false"
              dense
              outlined
              input-debounce="500"
              :label="
                !tagStatusModel || !tagStatusModel.length
                  ? $t('filter_empty')
                  : ''
              "
              ref="tag_status_select"
              :hide-dropdown-icon="false"
              :options="tagStatusOptions"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("no_data_found") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <!-- movement type -->
          <div class="row no-wrap items-baseline" v-else-if="theModel.Descriptor === 11">
            <q-select
              flat
              v-model="moveTypeModel"
              class="no-select-border q-mb-xs"
              hide-bottom-space
              multiple
              :label-slot="false"
              :bottom-slots="false"
              dense
              outlined
              input-debounce="500"
              :label="
                !moveTypeModel || !moveTypeModel.length
                  ? $t('filter_empty')
                  : ''
              "
              ref="move_type_select"
              :hide-dropdown-icon="false"
              options-html
              :options="moveTypeOptions"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("no_data_found") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <!-- file attachment filter -->
          <div v-else-if="theModel.Descriptor === 6">
            <q-select
              flat
              v-model="attachStatusModel"
              class="no-select-border q-mb-xs"
              hide-bottom-space
              multiple
              :label-slot="false"
              :bottom-slots="false"
              dense
              outlined
              clearable
              input-debounce="500"
              :label="
                !attachStatusModel || !attachStatusModel.length
                  ? $t('filter_empty')
                  : ''
              "
              ref="attach_status_select"
              :hide-dropdown-icon="false"
              :options="attachStatusOptions"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t("no_data_found") }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </q-item-section>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/**
 * single filter display and editing element
 */

import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import { getFiltersTypeName } from "@/models/helpers/type-names";
import {
  LastMovementOfStorageItemFilterGroupDto,
  MovementTypeFilterGroupDto,
  NumberFilterDto,
  NumberFilterGroupDto,
  SelectionDateStampsFilterGroupSend,
  SelectionEntityWithRolesFilterGroupSend,
  SelectionFileAttachmentFilterGroupSend,
  SelectionFilterGroupSend,
  SelectionJobStatusFilterGroupSend,
  SelectionParametersFilterGroupSend,
  SelectionProjectStageFilterGroupSend,
  SelectionStorageItemNameFilterGroupDto,
  SelectionTagStatusFilterGroupSend,
  SelectionTextFilterGroupSend,
  StorageOfMovementFilterGroupDto,
} from "@/models/interfaces/entity-settings/filters/group-filters";
import {
  JobStatusFilterFlags,
  MovementTypeFilterFlagsDto,
  NumberFilterCompareTypeDto,
  SelectionFileAttachmentFilter,
  SelectionFilterGroupSendCategory,
  SelectionFilterGroupSendDescriptor,
  SelectionFilterSendConnector,
  StorageFilterTypeFlagsDto,
  TagStatusFilterFlags,
} from "@/models/etc/types";
import TextItemElement from "./group-list-items/TextItemElement.vue";
import AttachmentItemElement from "./group-list-items/AttachmentItemElement.vue";
import DatestampItemElement from "./group-list-items/datestamp-items/DatestampItemElement.vue";
import EWRItemElement from "./group-list-items/EWRItemElement.vue";
import JobStatusItemElement from "./group-list-items/JobStatusItemElement.vue";
import ProjectStageItemElement from "./group-list-items/datestamp-items/ProjectStageItemElement.vue";
import ParameterItemElement from "./group-list-items/ParameterItemElement.vue";
import SelectorPopup from '../aux-selector/SelectorPopup.vue';
import DateRangeDisplayItem from "../basic/data-components/DateRangeDisplayItem.vue";
import VariableDisplayList from "../basic/VariableDisplayList.vue";

import {
  SelectionDateStampsFilterSend,
  SelectionEntityWithRolesFilterSend,
  SelectionStorageItemNameFilterDto,
  SelectionTextFilterSend,
} from "@/models/interfaces/entity-settings/filters/filters";
import { rootStore } from "@/store";
import { settingsStore } from "@/store/settings";
// import { storeToRefs } from 'pinia';
import _ from "lodash";
import { reactive } from "vue";
import { generalStore } from "@/store/general";
import { storagePositionsStore } from "../../../store/storage/storage-positions";
import { mapCreateContainerToInstance } from "../../../models/helpers/parameter-helpers";
import MostaCheckbox from '@/components/common/basic/MostaCheckbox.vue';
import { AuxSelectorDataType } from '@/components/common/aux-selector/types';
import AccessFilterDropdownContent from './AccessFilterDropdownContent.vue';

// types all containing Filters field
type filterTypes =
  | SelectionTextFilterGroupSend
  | SelectionEntityWithRolesFilterGroupSend
  | SelectionDateStampsFilterGroupSend
  | LastMovementOfStorageItemFilterGroupDto
  | SelectionProjectStageFilterGroupSend;

@Component({
  name: "FilterListElement",
  components: {
    TextItemElement,
    EWRItemElement,
    JobStatusItemElement,
    DatestampItemElement,
    ProjectStageItemElement,
    AttachmentItemElement,
    ParameterItemElement,
    VariableDisplayList,
    DateRangeDisplayItem,
    MostaCheckbox,
    SelectorPopup,
    AccessFilterDropdownContent,
  },
})
export default class FilterListElement extends Vue {
  get accessFilterDropdownWidth(): number {
    return 697;
  }

  get accessFilterDropdownHeight(): number {
    return 559;
  }

  get displayFilterDescriptor(): SelectionFilterGroupSendDescriptor {
    return this.isAccessFilter
      ? SelectionFilterGroupSendDescriptor.EntityWithRoles
      : this.theModel.Descriptor;
  }

  get isOwnerFilter(): boolean {
    return Number(this.theModel?.Descriptor) === SelectionFilterGroupSendDescriptor.EntityWithRoles
      && [SelectionFilterGroupSendCategory.Owner, 48].includes(Number(this.theModel?.Category));
  }

  get isSpecialRulesFilter(): boolean {
    return Number(this.theModel?.Descriptor) === SelectionFilterGroupSendDescriptor.SpecialRules
      && [SelectionFilterGroupSendCategory.SpecialRules, 49].includes(Number(this.theModel?.Category));
  }

  get isAccessFilter(): boolean {
    return this.isOwnerFilter || this.isSpecialRulesFilter;
  }
  /** Workers / LinearChartWorkers — двухколоночный deps; стартовая ширина попапа шире. */
  get filterListSelectorWideLayout(): boolean {
    const tm = this.theModel as any;
    let modelType: number;
    if (tm.Descriptor === 4) {
      modelType = tm.Category === 12 ? 3 : tm.Category;
    } else {
      modelType =
        tm.Descriptor === 9 ? 22
        : tm.Category === 12 ? 3
        : tm.Descriptor === 10 ? 23
        : tm.Category;
    }
    return modelType === AuxSelectorDataType.Workers
      || modelType === AuxSelectorDataType.LinearChartWorkers;
  }

  // v-model input
  @Prop({ default: {} as SelectionFilterGroupSend })
  modelValue!: SelectionFilterGroupSend;
  // update v-model
  @Emit("update:modelValue") emitModelValue(arg: SelectionFilterGroupSend) {
    return arg;
  }

  @Prop({ default: -1 })
  inputIndex!: number;

  // did not pass validation
  isIncorrect: string = "";

  rootstore: any;
  genstore: any;
  setstore: any;
  // setstore: any
  storage_pos: any;
  isShowingMenu: boolean = false;

  useInnerModel: boolean = false;
  innerRange: SelectionDateStampsFilterSend = reactive({
    Positive: true,
    StartDate: new Date(),
    EndDate: undefined,
    EndDateIsToday: true,
  });

  moveFlagSetConditions: any[] = reactive([])
  private _commonRangeSyncPending = false;

  h = 100;
  w = 100;
  active = true;

  @Watch("innerRange", { deep: true })
  range_watcher(val: SelectionDateStampsFilterSend) {
    if (this.theModel.Descriptor === 3) {
      if (!this.useInnerModel) {
        console.log("null common range");
        (this.theModel as SelectionProjectStageFilterGroupSend).CommonRange =
          null;
      } else if (
        val &&
        !_.isEqual(
          val,
          (this.theModel as SelectionProjectStageFilterGroupSend).CommonRange
        )
      ) {
        console.log("common range");
        (this.theModel as SelectionProjectStageFilterGroupSend).CommonRange =
          val;
      }
      this.emitModelValue(this.theModel);
    }
  }

  created() {
    this.rootstore = rootStore();
    this.setstore = settingsStore();
    this.genstore = generalStore();
    this.storage_pos = storagePositionsStore();

    if (this.isOwnerFilter) {
      this.theModel.FilterConnector = SelectionFilterSendConnector.Or;
    }

    if (this.theModel.Descriptor === SelectionFilterGroupSendDescriptor.StoragesOfMovement) {
      this.moveFlagSetConditions = this.movementFlagOptions.filter((mask: any) => {
        return ((this.theModel as StorageOfMovementFilterGroupDto).CommonStorageFilterTypeFlags & mask.value) !== 0
      })
    }

    const cr = (this.modelValue as SelectionProjectStageFilterGroupSend)
      .CommonRange;
    this.useInnerModel = cr !== null && cr !== undefined;
  }

  get filtersValidationMutated() {
    return _.cloneDeep(this.setstore?.getFilterValidation);
  }

  @Watch('moveFlagSetConditions', { deep: true })
  move_flats_watcher(val: any[]) {
    if (this.theModel.Descriptor !== SelectionFilterGroupSendDescriptor.StoragesOfMovement) { return }
    (this.theModel as StorageOfMovementFilterGroupDto).CommonStorageFilterTypeFlags = 0
    if (!val || !val.length) { return }

    val.forEach((el: any) => {
      (this.theModel as StorageOfMovementFilterGroupDto).CommonStorageFilterTypeFlags |= el.value;
    })
  }

  @Watch("filtersValidationMutated", { deep: true })
  updateIncorrect(val: any) {
    this.isIncorrect =
      val.find(
        (el: any) =>
          el.filterDescriptor === this.theModel.Descriptor &&
          el.filterCategory === this.theModel.Category
      )?.errorText || "";
  }

  @Watch("modelValue.FilterConnector")
  keepOwnerConnectorOr() {
    if (
      this.isOwnerFilter &&
      this.theModel.FilterConnector !== SelectionFilterSendConnector.Or
    ) {
      this.theModel.FilterConnector = SelectionFilterSendConnector.Or;
    }
  }

  // Синхронизация локального useInnerModel при внешнем обнулении CommonRange (массовый сброс фильтров).
  // nextTick + защёлка: ловим финальное значение один раз после всех синхронных мутаций.
  @Watch("modelValue.CommonRange")
  onCommonRangeExternalChange() {
    if (this.theModel.Descriptor !== 3 || this._commonRangeSyncPending) return;
    this._commonRangeSyncPending = true;
    this.$nextTick(() => {
      this._commonRangeSyncPending = false;
      const cr = (this.modelValue as SelectionProjectStageFilterGroupSend).CommonRange;
      const shouldBeOn = cr !== null && cr !== undefined;
      if (this.useInnerModel !== shouldBeOn) {
        this.useInnerModel = shouldBeOn;
      }
    });
  }

  @Watch("useInnerModel", { deep: true })
  use_watcher(val: boolean) {
    console.log("use inner model " + val);
    if (val) {
      const cr = (this.modelValue as SelectionProjectStageFilterGroupSend)
        .CommonRange;
      if (cr !== null && cr !== undefined) {
        this.innerRange = reactive({
          Positive: true,
          StartDate:
            cr !== null && cr !== undefined ? cr.StartDate : new Date(),
          EndDate: cr !== null && cr !== undefined ? cr.EndDate : undefined,
          EndDateIsToday:
            cr !== null && cr !== undefined ? cr.EndDateIsToday : true,
        });
      }
    }
    this.innerRange && this.range_watcher(this.innerRange);
  }

  // basic model
  get theModel(): SelectionFilterGroupSend {
    if (this.modelValue) {
      const cr = (this.modelValue as SelectionProjectStageFilterGroupSend)
        .CommonRange;
      if (cr !== null && cr !== undefined) {
        this.innerRange = reactive({
          Positive: true,
          StartDate:
            cr !== null && cr !== undefined ? cr.StartDate : new Date(),
          EndDate: cr !== null && cr !== undefined ? cr.EndDate : undefined,
          EndDateIsToday:
            cr !== null && cr !== undefined ? cr.EndDateIsToday : true,
        });
      }
    }
    return this.modelValue;
  }

  set theModel(val: SelectionFilterGroupSend) {
    this.emitModelValue(val);
  }

  get commonRoleOptions(): any[] {
    return (
      this.theModel as SelectionEntityWithRolesFilterGroupSend
    ).Roles?.map((el: any) => {
      return {
        label: el.Name,
        value: el,
      };
    });
  }

  // filter roles model
  get commonRolesModel(): any[] {
    if (!this.theModel) return [];
    return (
      this.theModel as SelectionEntityWithRolesFilterGroupSend
    ).SelectedCommonRoles.map((el: any) => {
      return {
        label: el.Name,
        value: el,
      };
    });
  }

  set commonRolesModel(val: any[]) {
    if (!this.theModel) return;

    const theonly_index = (val as any[]).findIndex(
      (el) => el.value.TheOnlyOption
    );
    let val_filtered: any[] = [];
    if (theonly_index > -1) {
      // toggle
      if (
        theonly_index >= 0 &&
        (
          this.theModel as SelectionEntityWithRolesFilterGroupSend
        ).SelectedCommonRoles.includes(val[theonly_index].value)
      ) {
        val_filtered = val;
        val_filtered.splice(theonly_index, 1);
      } else {
        val_filtered = [val[theonly_index]];
      }
    } else {
      val_filtered = val;
    }

    (this.$refs.roles_select as any).hidePopup();

    (
      this.theModel as SelectionEntityWithRolesFilterGroupSend
    ).SelectedCommonRoles = val_filtered.map((el: any) => {
      return el.value;
    });
  }

  // job status flags filter
  jobStatusName(arg: number): string {
    switch (arg) {
      case JobStatusFilterFlags.Completed:
        return this.$t("job_done");
      case JobStatusFilterFlags.Lost:
        return this.$t("job_expired");
      case JobStatusFilterFlags.Standard:
        return this.$t("job_is_record");
      case JobStatusFilterFlags.WaitingForCheck:
        return this.$t("job_waiting");
      case JobStatusFilterFlags.Working:
        return this.$t("job_in_progress");
      case JobStatusFilterFlags.Nothing:
      default:
        return this.$t("filter_empty");
    }
  }

  get jobStatusOptions() {
    switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.JobStatus:
        return Object.values(JobStatusFilterFlags)
          .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
          .map((vm) => {
            return {
              label: this.jobStatusName(Number(vm)),
              value: Number(vm),
            };
          });
      default:
        return [];
    }
  }

  get jobStatusModel() {
    return this.jobStatusOptions.filter((mask: any) => {
      return (
        ((this.theModel as SelectionJobStatusFilterGroupSend).JobStatusFlags &
          mask.value) !==
        0
      );
    });
  }

  set jobStatusModel(mask: any[]) {
    (this.theModel as SelectionJobStatusFilterGroupSend).JobStatusFlags = 0;
    if (!mask || !mask.length) {
      return;
    }

    mask.forEach((mask) => {
      (this.theModel as SelectionJobStatusFilterGroupSend).JobStatusFlags |=
        mask.value;
    });
  }

  // file attachment status flags filter
  attachStatusName(arg: number): string {
    switch (arg) {
      case SelectionFileAttachmentFilter.Client:
        return this.$t("files_clients_attachment");
      case SelectionFileAttachmentFilter.Project:
        return this.$t("files_projects_attachment");
      case SelectionFileAttachmentFilter.None:
      default:
        return this.$t("filter_empty");
    }
  }

  get attachStatusOptions() {
    switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.FileAttachment:
        return Object.values(SelectionFileAttachmentFilter)
          .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
          .map((vm) => {
            return {
              label: this.attachStatusName(Number(vm)),
              value: Number(vm),
            };
          });
      default:
        return [];
    }
  }

  get attachStatusModel() {
    return this.attachStatusOptions.filter((mask: any) => {
      return (
        ((this.theModel as SelectionFileAttachmentFilterGroupSend)
          .FileAttachmentFilter &
          mask.value) !==
        0
      );
    });
  }

  set attachStatusModel(mask: any[]) {
    (
      this.theModel as SelectionFileAttachmentFilterGroupSend
    ).FileAttachmentFilter = 0;
    if (!mask || !mask.length) {
      return;
    }

    mask.forEach((mask) => {
      (
        this.theModel as SelectionFileAttachmentFilterGroupSend
      ).FileAttachmentFilter |= mask.value;
    });
  }

  // tag status flags filter
  tagStatusName(arg: number): string {
    switch (arg) {
      // case TagStatusFilterFlags.Both:
      // return this.$t('both_label')
      case TagStatusFilterFlags.Standard:
        return this.$t("normal_label");
      case TagStatusFilterFlags.Hidden:
        return this.$t("hidden_upcase");
      case TagStatusFilterFlags.Nothing:
      default:
        return this.$t("filter_empty");
    }
  }

  get tagStatusOptions() {
    switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.TagStatus:
        return Object.values(TagStatusFilterFlags)
          .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
          .map((vm) => {
            return {
              label: this.tagStatusName(Number(vm)),
              value: Number(vm),
            };
          });
      default:
        return [];
    }
  }

  get tagStatusModel() {
    return this.tagStatusOptions.filter((mask: any) => {
      return (
        ((this.theModel as SelectionTagStatusFilterGroupSend).TagStatusFlags &
          mask.value) !==
        0
      );
    });
  }

  set tagStatusModel(mask: any[]) {
    (this.theModel as SelectionTagStatusFilterGroupSend).TagStatusFlags = 0;
    if (!mask || !mask.length) {
      return;
    }

    mask.forEach((mask) => {
      (this.theModel as SelectionTagStatusFilterGroupSend).TagStatusFlags |=
        mask.value;
    });
  }

  // actual filters
  deleteItem(del_index: number) {
    if (this.theModel.Descriptor === 4) {
      (this.theModel as SelectionParametersFilterGroupSend).Parameters[
        del_index
      ].Selected = false;
    } else {
      // @ts-ignore
      (this.theModel as filterTypes).Filters.splice(del_index, 1);
    }
  }

  get getElementName(): string {
    // @ts-ignore
    return getFiltersTypeName(
      this.theModel.Category,
      this.genstore && this.genstore.selectedItem
        ? this.genstore.selectedItem.DestType
        : this.rootstore.generalMode
    );
  }

  addTextFilter() {
    const new_el: SelectionTextFilterSend = {
      Positive: true,
      Value: "",
    };
    // @ts-ignore
    (this.theModel as SelectionTextFilterGroupSend).Filters.push(new_el);
  }

  addStorageNameFilter() {
    // console.log(this.storage_pos?.currentItemNameContainer)
    // if (
    //   !this.storage_pos?.currentItemNameContainer ||
    //   !this.storage_pos?.currentItemNameContainer.ParameterContainer
    // ) {
    //   return;
    // }

    const new_el: SelectionStorageItemNameFilterDto = {
      Container: this.storage_pos?.currentItemNameContainer && this.storage_pos?.currentItemNameContainer.ParameterContainer ? reactive(
        mapCreateContainerToInstance(
          this.storage_pos?.currentItemNameContainer.ParameterContainer,
          true
        )[0]
      ) : undefined,
      VendorCode: "",
      Positive: true,
      UseVendorCode: true,
    };
    (this.theModel as SelectionStorageItemNameFilterGroupDto).Filters.push(
      new_el
    );
  }

  addNumberFilter() {
    const new_el: NumberFilterDto = {
      Value: 0,
      CompareType: this.theModel.Category === SelectionFilterGroupSendCategory.Count ? NumberFilterCompareTypeDto.More : NumberFilterCompareTypeDto.Equals,
    };
    (this.theModel as NumberFilterGroupDto).Filters.push(new_el);
  }

  // movement type icon span
  moveTypeName(arg: number): string {
    switch (arg) {
      // case MovementTypeFilterFlagsDto.Both:
      // return this.$t('both_label')
      case MovementTypeFilterFlagsDto.Expense:
        return '<span class="q-mr-xs no-break movement-element movement-element--expense"/>'+this.$t("expense_label");
      case MovementTypeFilterFlagsDto.Income:
        return '<span class="q-mr-xs no-break movement-element movement-element--income"/>'+this.$t("income_label");
      case MovementTypeFilterFlagsDto.Transfer:
        return `<span class="q-mr-xs no-break movement-element movement-element--transfer"/>`+this.$t("transfer_label");
      case MovementTypeFilterFlagsDto.None:
      default:
        return this.$t("filter_empty");
    }
  }

  // movement type icon span
  moveTypeNameIconOnly(arg: number): string {
    switch (arg) {
      // case MovementTypeFilterFlagsDto.Both:
      // return this.$t('both_label')
      case MovementTypeFilterFlagsDto.Expense:
        return '<span class="q-mr-xs no-break movement-element movement-element--expense"/>';
      case MovementTypeFilterFlagsDto.Income:
        return '<span class="q-mr-xs no-break movement-element movement-element--income"/>';
      case MovementTypeFilterFlagsDto.Transfer:
        return `<span class="q-mr-xs no-break movement-element movement-element--transfer"/>`;
      case MovementTypeFilterFlagsDto.None:
      default:
        return this.$t("filter_empty");
    }
  }

  get moveTypeOptions() {
    switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.MovementTypes:
      case SelectionFilterGroupSendDescriptor.LastMovementOfStorageItem:
        return Object.values(MovementTypeFilterFlagsDto)
          .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
          .map((vm) => {
            return {
              label: this.theModel?.Descriptor === SelectionFilterGroupSendDescriptor.LastMovementOfStorageItem ? this.moveTypeNameIconOnly(Number(vm)) : this.moveTypeName(Number(vm)),
              value: Number(vm),
            };
          });
      default:
        return [];
    }
  }

  get moveTypeModel() {
    return this.moveTypeOptions.filter((mask: any) => {
      switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.MovementTypes:
        return (
          ((this.theModel as MovementTypeFilterGroupDto).MovementTypeFilterFlags &
            mask.value) !==
          0
        );
      case SelectionFilterGroupSendDescriptor.LastMovementOfStorageItem:
        return (
          ((this.theModel as LastMovementOfStorageItemFilterGroupDto).LastMovementTypeFilterFlags &
            mask.value) !==
          0
        );
      }
    });
  }

  set moveTypeModel(mask: any[]) {
    switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.MovementTypes:
        (this.theModel as MovementTypeFilterGroupDto).MovementTypeFilterFlags = 0;
        if (!mask || !mask.length) {
          return;
        }

        mask.forEach((mask) => {
          (this.theModel as MovementTypeFilterGroupDto).MovementTypeFilterFlags |=
            mask.value;
        });
        break;
      case SelectionFilterGroupSendDescriptor.LastMovementOfStorageItem:
        (this.theModel as LastMovementOfStorageItemFilterGroupDto).LastMovementTypeFilterFlags = 0;
        if (!mask || !mask.length) {
          return;
        }

        mask.forEach((mask) => {
          (this.theModel as LastMovementOfStorageItemFilterGroupDto).LastMovementTypeFilterFlags |=
            mask.value;
        });
        break;
      default:
        break;
    }
  }

  movementFlagName(arg: number): string {
    switch (arg) {
      case StorageFilterTypeFlagsDto.Receiver:
        return this.$t("storage_receiver");
      case StorageFilterTypeFlagsDto.Source:
        return this.$t("storage_source");
      case StorageFilterTypeFlagsDto.None:
      default:
        return this.$t("filter_empty");
    }
  }

  get movementFlagOptions() {
    switch (this.theModel?.Descriptor) {
      case SelectionFilterGroupSendDescriptor.StoragesOfMovement:
        return Object.values(StorageFilterTypeFlagsDto)
          .filter((v) => !isNaN(Number(v)) && Number(v) > 0)
          .map((vm) => {
            return {
              label: this.movementFlagName(Number(vm)),
              value: Number(vm),
            };
          });
      default:
        return [];
    }
  }

  changeMoveFlagModel(val: any) {
    if (!this.theModel ||
    this.theModel.Descriptor !== SelectionFilterGroupSendDescriptor.StoragesOfMovement) { return }
    this.moveFlagSetConditions = this.movementFlagOptions.filter((el: any) => val.includes(el.value))
  }

  // date filter
  addDateFilter() {
    const def_date = new Date();
    // def_date.setHours(0);
    // def_date.setMinutes(0);
    // def_date.setSeconds(0);
    // def_date.setMilliseconds(0);

    const new_el: SelectionDateStampsFilterSend = {
      Positive: true,
      StartDate: def_date,
      EndDate: def_date,
      EndDateIsToday: false,
    };
    // @ts-ignore
    (this.theModel as SelectionDateStampsFilterGroupSend).Filters.push(new_el);
  }

  addAddressFilter() {
    const new_el: SelectionEntityWithRolesFilterSend = {
      Entity: { Name: "", Id: 0 },
      Roles: [],
      Positive: true,
    };
    // @ts-ignore
    (this.theModel as SelectionProjectStageFilterGroupSend).Filters.push(new_el);
  }

  onPanelClosed(ind: number) {
    if (ind === this.inputIndex) {
      this.isShowingMenu = false;
    }
  }

  addNewFilter(e: any) {
    // @ts-ignore
    switch (this.theModel.Descriptor) {
      case SelectionFilterGroupSendDescriptor.Text:
        this.addTextFilter();
        break;
      case SelectionFilterGroupSendDescriptor.EntityWithRoles:
        this.theModel.Category === SelectionFilterGroupSendCategory.Address &&
          this.addAddressFilter();
        break;
      case SelectionFilterGroupSendDescriptor.Datestamps:
      case SelectionFilterGroupSendDescriptor.LastMovementOfStorageItem:
        this.addDateFilter();
        break;
      case SelectionFilterGroupSendDescriptor.StorageItemNames:
        this.addStorageNameFilter();
        break;
      case SelectionFilterGroupSendDescriptor.Numbers:
        this.addNumberFilter();
        break;
      // case SelectionFilterGroupSendDescriptor.StoragesOfMovement:
      //   this.addMovementStorageFilter();
      //   break;

      // here selector
      // case SelectionFilterGroupSendDescriptor.ProjectStages:
      //   this.addProjectStageFilter();
      //   break
      default:
        break;
    }

    if (
      this.isAccessFilter ||
      (this.theModel.Descriptor === 1 && this.theModel.Category !== 6) ||
      [3, 4, 9, 10].includes(this.theModel.Descriptor)
    ) {
      this.isShowingMenu = !this.isShowingMenu;
    }
  }
}
</script>

<style lang="scss">

.filter-andor-toggle {
  margin: 2px 12px 2px 6px;
  .q-btn--dense {
    padding: 0 12px !important;
    line-height: normal !important;
    min-height: 1.25rem;
    max-height: 1.25rem;
  }

  & > .q-btn-item {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
}

.filter-selection {
  &--child {
    margin-left: 26px !important;
  }
}

.unset-items-center {
  height: 24px !important;
  margin-top: 0;
}

.filter-item {
  .q-item__section--avatar {
    padding-left: 0 !important;
  }
}

.filter-list-el {
  .q-toggle__track,
  .q-toggle__thumb {
    font-size: 30px !important;
  }

  .q-checkbox__icon-container {
    font-size: 35px !important;
  }

  .q-btn.unset-items-center .q-icon {
    font-size: 18px !important;
  }

  .q-btn.q-pa-none.q-ma-none .q-icon {
    font-size: 14px !important;
  }
}
</style>
